import React = require('react');
import IconTextButton from "diy/custom-components/icon-text-button/IconTextButton";
import l10n = require('diy/util/l10n');

import CropSquareIcon from 'material-ui/svg-icons/image/crop-square';
import CropLandscapeIcon from 'material-ui/svg-icons/image/crop-landscape';

export interface FullWidthViewProps extends React.Props<FullWidthView> {
    isToggled: boolean;
    onToggleSwitch: Function;
}

interface FullWidthViewState {}

export default class FullWidthView extends React.Component<FullWidthViewProps, FullWidthViewState> {
    render() {
        return (
            <div>
                <div style={{
                    fontFamily: "open sans",
                    fontSize: '14px',
                    lineHeight: '14px',
                    paddingBottom: 10,
                    color: '#666'
                }}>{l10n.getString('section.fullWidth.title')}</div>
                <IconTextButton
                    text={l10n.getString('section.fullWidth.buttons.normal.label')}
                    Icon={<CropSquareIcon/>}
                    style={{marginRight: 3}}
                    onTouchTap={
                        () => this.props.onToggleSwitch(false)
                    }
                    useAlternativeColors={true}
                    isPressed={this.props.isToggled === false}
                    dataTestId="section-normal-width-option"
                />
                <IconTextButton
                    text={l10n.getString('section.fullWidth.buttons.fullWidth.label')}
                    Icon={<CropLandscapeIcon/>}
                    onTouchTap={
                        () => this.props.onToggleSwitch(true)
                    }
                    useAlternativeColors={true}
                    isPressed={this.props.isToggled === true}
                    dataTestId="section-full-width-option"
                />
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/components/basic/FullWidthView.tsx
 **/